/**
 * Nombre entier avec séparateur de milliers : « 1523619 » devient « 1 523 619 ».
 *
 * L'espace est insécable, pour qu'un total ne se coupe pas en fin de ligne. On découpe à la
 * main plutôt qu'avec `toLocaleString('fr-FR')`, dont l'espace (fine ou non) varie selon le
 * navigateur.
 */
export function formatThousands(value) {
  if (value === null || value === undefined || value === '' || isNaN(value)) {
    return value
  }

  return String(parseInt(value, 10)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export default formatThousands



// WEBPACK FOOTER //
// ./src/filters/number.js